<template>
    <div>
        <form @submit.prevent="submitReview()"
              v-if="! complete"
        >
            <form-select v-model="form.rating"
                         label="Rating"
                         :options="[
                             { name: '5', value: 5 },
                             { name: '4', value: 4 },
                             { name: '3', value: 3 },
                             { name: '2', value: 2 },
                             { name: '1', value: 1 },
                         ]"
                         :track-as-integer="true"
                         track-by="value"
                         :error="getErrorFor('rating')"
            ></form-select>

            <form-textarea v-model="form.review"
                           label="Review"
                           class="mt-6"
                           :rows="8"
                           :error="getErrorFor('review')"
            ></form-textarea>

            <form-button type="submit"
                         class="mt-6"
            >
                Submit Review
            </form-button>
        </form>

        <p v-else>
            Thank you for submitting your review. If approved to will appear on the site for the event.
        </p>
    </div>
</template>

<script>
    import FormTextarea from "../form/Textarea";
    import FormSelect from "../form/Select";
    import FormButton from "../form/Button";

    import Form from "../../mixins/Form";
    import route from "ziggy-js";

    export default {
        data() {
            return {
                baseUrl: '',

                submitting: false,
                complete: false,

                form: {
                    rating: 5,
                    review: '',
                }
            }
        },

        props: {
            seatId: {
                type: Number,
                required: true,
            }
        },

        components: { FormTextarea, FormSelect, FormButton },

        mixins: [Form],

        created() {
            this.baseUrl = route('customer.reviews.store', this.seatId).url();
        },

        methods: {
            submitReview() {
                if (this.submitting) return false;

                this.submitting = true;

                this.submitForm(false)
                    .then(() => {
                        this.complete = true;

                        setTimeout(() => {
                            window.location = `${route('customer.dashboard')}`;
                        }, 5000);
                    })
                    .catch(() => {
                        this.submitting = false;
                    })
            }
        }
    }
</script>
